import * as React from "react";
import type { SVGProps } from "react";

const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={8}
    viewBox="0 0 12 8"
    {...props}
  >
    <path
      fill="#142745"
      fillRule="evenodd"
      d="M.351.351a1.2 1.2 0 0 1 1.698 0l3.813 3.814L9.677.351a1.201 1.201 0 0 1 1.697 1.698L6 7.423l-.138-.138-.137.138L.351 2.049a1.203 1.203 0 0 1 0-1.699z"
    />
  </svg>
);
export default SvgArrowDown;
